import { render } from "./RegistrationEd.vue?vue&type=template&id=03ad52da"
import script from "./RegistrationEd.vue?vue&type=script&lang=js"
export * from "./RegistrationEd.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__